interface IProps {
  label: string
  required?: boolean,
  className?: string
}
export const FormLabel = ({ required, label, className }: IProps) => {
  return (<div className={`flex items-center gap-2 ${className}`}>
    {required && <span className="text-red-500">*</span>}
    <span className="font-bold text-lg">{label}</span>
  </div>)
}